import React, { useState } from 'react';
import { Form, Input, notification, Tooltip, Cascader, Select, Row, Col, Button, AutoComplete, message } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import './AddPart.scss';
import Lang from '../../Language';
import SupplierService from '../../../utils/api/suppliers';

export default function () {
    let token = localStorage.getItem('token');
    const [form] = Form.useForm();
    const [load, setLoad] = useState(false);

    const sendForm = (values) => {
        setLoad(true);

        SupplierService.AddPart(values)
            .then(response => {
                if (response.data?.success === true) {
                    openNotification();
                    form.resetFields();
                } else {
                    const errorMsg = response.data?.message || "Hubo un error al dar de alta el numero de parte.";
                    message.error(errorMsg !== "undefined" ? errorMsg : "Error desconocido");
                }
                setLoad(false);
            })
            .catch(error => {
                console.error("Error en AddPart:", error);
                const errorMsg = error.response?.data?.message || 
                               error.message || 
                               "Hubo un error al procesar la solicitud";
                message.error(errorMsg !== "undefined" ? errorMsg : "Error desconocido");
                setLoad(false);
            });
    };

    const tooltipIcon = (labelNo) => {
        const tooltipText = Lang("AddPart", labelNo);
        return (
            <span>
                <Tooltip title={tooltipText || `Tooltip para ${labelNo}`}>
                    <QuestionCircleOutlined />
                </Tooltip>
            </span>
        );
    };

    const inputCompanion = (labelNo, tooltiplabel) => {
        const placeholder = Lang("AddPart", labelNo);
        return {
            placeholder: placeholder || `Placeholder ${labelNo}`,
            suffix: tooltipIcon(tooltiplabel)
        };
    };

    const openNotification = () => {
        const key = `open${Date.now()}`;

        notification.open({
            message: 'Nuevo número de parte',
            description: 'Has agregado un nuevo número de parte, recuerda que este no se verá reflejado en tu lista hasta que un agente de EP&O lo confirme.',
            key,
        });
    };

    return (
        <Form
            name="nest-messages"
            form={form}
            method="POST"
            layout="vertical"
            onFinish={sendForm}
        >
            <Row gutter={[12, 12]}>
                <Col xs={24}>
                    <Form.Item
                        name="name"
                        label={Lang("AddPart", "1") || "Nombre"}
                        rules={[{
                            type: "string",
                            required: true,
                            message: Lang("AddPart", "2") || "Favor de agregar el nombre"
                        }]}
                    >
                        <Input 
                            {...inputCompanion("3", "4")}
                            name='name'
                        />
                    </Form.Item>

                    <Form.Item
                        name='supplier_partno'
                        label={Lang("AddPart", "5") || "Número de parte"}
                        rules={[{
                            type: "string",
                            required: true,
                            message: Lang("AddPart", "6") || "Favor de agregar el número de parte"
                        }]}
                    >
                        <Input 
                            {...inputCompanion("7", "8")}
                            name='supplier_partno'
                        />
                    </Form.Item>

                    <Form.Item
                        name="max_qty"
                        initialValue={1}
                        label={Lang("AddPart", "9") || "Cantidad máxima"}
                        rules={[{
                            required: true,
                            message: Lang("AddPart", "10") || "Favor de agregar la cantidad máxima"
                        }]}
                    >
                        <Input
                            min={1}
                            type="number"
                            name="max_qty"
                            {...inputCompanion("10", "11")}
                        />
                    </Form.Item>
                    
                    <Form.Item
                        name="min_qty"
                        initialValue={1}
                        label={Lang("AddPart", "18") || "Cantidad mínima"}
                        rules={[{
                            required: true,
                            message: Lang("AddPart", "20") || "Favor de agregar la cantidad mínima"
                        }]}
                    >
                        <Input
                            min={1}
                            type="number"
                            name="min_qty"
                            {...inputCompanion("18", "19")}
                        />
                    </Form.Item>
                    
                    <Form.Item
                        initialValue={1}
                        name="current_qty"
                        label={Lang("AddPart", "22") || "Cantidad disponible"}
                        rules={[{
                            required: true,
                            message: Lang("AddPart", "23") || "Favor de agregar la cantidad disponible"
                        }]}
                    >
                        <Input
                            min={0}
                            type="number"
                            name="current_qty"
                            {...inputCompanion("22", "24")}
                        />
                    </Form.Item>
                    
                    <Form.Item
                        name="subtotal"
                        label="Precio"
                        rules={[{
                            required: true,
                            message: 'Favor de agregar el precio del número de parte'
                        }]}
                    >
                        <Input
                            min={0}
                            step="0.01"
                            type="number"
                            name="subtotal"
                            {...inputCompanion("21", "17")}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24}>
                    <Form.Item>
                        <Button 
                            type="primary" 
                            htmlType="submit" 
                            loading={load} 
                            style={{ width: "100%" }}
                        >
                            Crear
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    );
}